import get from 'lodash-es/get';
import { Injectable } from '@angular/core';
import { ChartData, ChartTypes } from '../models/chart.model';
import { msToMinutesSecondsWithUnit } from '../helpers/ms-to-minutes-seconds';

@Injectable()
export class ChartValueFormatterService {
  public formatValue(value: number, chartType: ChartTypes) {
    if (chartType === 'percentage') {
      return `${value}%`;
    }

    if (chartType === 'time') {
      const timeWithUnitObject = msToMinutesSecondsWithUnit(value);
      return timeWithUnitObject.value;
    }

    return value;
  }

  private getTooltipValue(value, item) {
    const type = get(item, 'type');

    if (type !== 'time') {
      return `${this.formatValue(value, type)} ${get(item, 'unit', '')}`;
    }
    const timeObj = msToMinutesSecondsWithUnit(value);
    return `${timeObj.value} ${timeObj.unit}`;
  }

  public formatTooltip(params: any[], chartData: ChartData[]): string {
    const content = params
      .reverse() // Reverse data so primary is first
      .map((data) => {
        const item = chartData.find((chart) => chart.name === data.seriesName);
        return `
        <div class="tooltip-item">
          <span class="tooltip-item-color" style="background:${data.color};"></span>
          <div class="tooltip-content">
            <span>${data.seriesName}:</span>
            <span class="tooltip-value">
              ${this.getTooltipValue(data.value, item)}
            </span>
          </div>
        </div>`;
      })
      .join('');

    return `
    <div class="tooltip">
      ${content}
    </div>
  `;
  }
}
